export const GET_DEPOSIT_TOMAN_TRANSACTIONS = `/api/v1/financial-coordinator/toman/deposit/history`;
export const GET_WITHDRAW_TOMAN_TRANSACTIONS = `/api/v1/financial-coordinator/toman/withdraw/history`;
export const GET_DEPOSIT_CRYPTO_TRANSACTIONS = `/api/v1/financial-coordinator/crypto/deposit/transaction/history`;
export const GET_WITHDRAW_CRYPTO_TRANSACTIONS = `/api/v1/financial-coordinator/crypto/withdraw/history`;
export const GET_FIAT_OTC_HISTORY = `/api/v1/financial-coordinator/otc/fiat-history`;
export const GET_EXCHANGE_OTC_HISTORY = `/api/v1/financial-coordinator/otc/exchange-history`;
export const GET_DISTRIBUTION_HISTORY = `/api/v1/financial-coordinator/distributions/history`;
export const GET_P2P_ORDERS_HISTORY = `/api/v1/financial-coordinator/p2p/order/history`;
export const GET_NETWORK_LIST = `/api/v1/wallet/network/list`;
